

class Request{
 
    constructor({   
       requestedBy = undefined,
       requestType = undefined,
       timeStamp = -1
       }= {} ) {
           Object.assign( this, { requestedBy, requestType });
           //this.timeStamp = new Date().getTime();
    }

}
   
Request.RequestType = Object.freeze({
    Play: "Play",
    Pause: "Pause",
    Stop: "Stop",
    Reset: "Reset",
    JumpToTimePosition: "JumpToTimePosition",
    ChangeVolume: "ChangeVolume"
})
    
export {Request}